export class EntityClaimRakurakuHistory {
public c_claim_rakuraku_history_id:number | null = null;
public c_claim_id:number | null = null;
public c_docfile_id:number | null = null;
public c_claim_rakuraku_history_reg_user:string | null = null;
public c_claim_rakuraku_history_reg_at:Date | null = null;
public c_claim_rakuraku_history_upd_user:string | null = null;
public c_claim_rakuraku_history_upd_at:Date | null = null;
}